import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { useCookies } from "react-cookie";
import HeroImg1 from "../../../Image.png";
import HeroImg2 from "../../../image_2.png";
import HeroImg3 from "../../../image_3.png";
import HeroImg4 from "../../../image_4.png";
import HeroImg5 from "../../../image_5.png";
import HeroImg6 from "../../../image_6.png";
import HeroImg7 from "../../../image_7.png";
import "./css/Hero.css";

const CREATORS = [
  { img: HeroImg1, name: "Aisha Verma",   niche: "Fashion · Lifestyle · Mumbai",     followers: "248K",  engagement: "4.8%", authScore: "91/100", engLabel: "↑ Above average", authLabel: "Real audience" },
  { img: HeroImg2, name: "Priya Menon",   niche: "Beauty · Skincare · Delhi",        followers: "512K",  engagement: "3.6%", authScore: "88/100", engLabel: "↑ Above average", authLabel: "Real audience" },
  { img: HeroImg4, name: "Rohit Kapoor",  niche: "Fitness · Health · Bangalore",     followers: "1.2M",  engagement: "5.1%", authScore: "94/100", engLabel: "↑ Top 5%",        authLabel: "Verified clean" },
  { img: HeroImg5, name: "Sneha Iyer",    niche: "Travel · Food · Hyderabad",        followers: "384K",  engagement: "4.2%", authScore: "89/100", engLabel: "↑ Above average", authLabel: "Real audience" },
  { img: HeroImg6, name: "Karan Mehta",   niche: "Tech · Gaming · Pune",             followers: "876K",  engagement: "6.3%", authScore: "92/100", engLabel: "↑ Top 3%",        authLabel: "High quality"  },
  { img: HeroImg7, name: "Deepa Nair",    niche: "Dance · Music · Chennai",          followers: "2.1M",  engagement: "4.9%", authScore: "87/100", engLabel: "↑ Above average", authLabel: "Real audience" },
  { img: HeroImg3, name: "Arjun Singh",   niche: "Comedy · Entertainment · Kolkata", followers: "667K",  engagement: "5.7%", authScore: "90/100", engLabel: "↑ Top 8%",        authLabel: "Verified clean" },
];
const CAROUSEL_IMAGES = CREATORS.map((c) => c.img);

/* ── Canvas particle animation ─────────────────────────── */
function initParticleCanvas(canvas) {
  const ctx = canvas.getContext("2d");
  let rafId, lastTs = 0, visible = true; // hero is always in viewport on load
  const FPS_CAP = 1000 / 30;

  const resize = () => {
    canvas.width  = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
  };
  resize();
  window.addEventListener("resize", resize, { passive: true });

  /* Pause when hero scrolls off-screen */
  /* Properly stop/restart the loop instead of re-queuing while invisible */
  const io = new IntersectionObserver(([e]) => {
    visible = e.isIntersecting;
    if (visible && !rafId) rafId = requestAnimationFrame(animate);
  }, { threshold: 0 });
  io.observe(canvas);

  const particles = Array.from({ length: 50 }, () => ({
    x:      Math.random() * canvas.width,
    y:      Math.random() * canvas.height,
    radius: Math.random() * 1.8 + 0.5,
    speedY: -(Math.random() * 0.55 + 0.25),
    speedX: (Math.random() - 0.5) * 0.3,
    coral:  Math.random() > 0.5,
  }));

  const blobs = Array.from({ length: 3 }, () => ({
    x:      Math.random() * canvas.width,
    y:      Math.random() * canvas.height,
    radius: Math.random() * 90 + 70,
    speedX: (Math.random() - 0.5) * 0.08,
    speedY: (Math.random() - 0.5) * 0.08,
  }));

  const animate = (ts) => {
    if (!visible) { rafId = null; return; }
    rafId = requestAnimationFrame(animate);
    if (ts - lastTs < FPS_CAP) return;
    lastTs = ts;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    blobs.forEach((b) => {
      b.x += b.speedX; b.y += b.speedY;
      if (b.x < -b.radius)               b.x = canvas.width  + b.radius;
      if (b.x > canvas.width + b.radius)  b.x = -b.radius;
      if (b.y < -b.radius)               b.y = canvas.height + b.radius;
      if (b.y > canvas.height + b.radius) b.y = -b.radius;
      const g = ctx.createRadialGradient(b.x, b.y, 0, b.x, b.y, b.radius);
      g.addColorStop(0, "rgba(255,107,53,0.07)");
      g.addColorStop(1, "transparent");
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(b.x, b.y, b.radius, 0, Math.PI * 2);
      ctx.fill();
    });

    particles.forEach((p) => {
      p.x += p.speedX; p.y += p.speedY;
      if (p.y < -p.radius)    { p.y = canvas.height + p.radius; p.x = Math.random() * canvas.width; }
      if (p.x < 0)             p.x = canvas.width;
      if (p.x > canvas.width)  p.x = 0;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
      ctx.fillStyle = p.coral ? "rgba(255,107,53,0.45)" : "rgba(255,255,255,0.12)";
      ctx.fill();
    });
  };
  rafId = requestAnimationFrame(animate);

  return () => {
    cancelAnimationFrame(rafId);
    io.disconnect();
    window.removeEventListener("resize", resize);
  };
}

/* ── Floating metric badge ─────────────────────────────── */
function MetricBadge({ label, value, sub, subColor, dark, style, delay }) {
  return (
    <Box
      className="badge-float"
      style={{ animationDelay: delay || "0s", ...style }}
      sx={{
        position:      "absolute",
        zIndex:        10,
        bgcolor:       dark ? "#0D1B3E" : "white",
        border:        dark ? "1px solid rgba(255,107,53,0.3)" : "1px solid rgba(0,0,0,0.06)",
        borderRadius:  "14px",
        p:             "11px 15px",
        boxShadow:     dark
          ? "0 12px 32px rgba(0,0,0,0.35)"
          : "0 12px 32px rgba(0,0,0,0.12)",
        minWidth:      "110px",
        backdropFilter: "blur(8px)",
      }}
    >
      <Typography sx={{ fontSize: "10px", color: dark ? "rgba(255,255,255,0.45)" : "#999", mb: "3px" }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: "20px", fontWeight: 800, color: dark ? "#FF6B35" : "#0D1B3E", lineHeight: 1 }}>
        {value}
      </Typography>
      {sub && (
        <Typography sx={{ fontSize: "10px", color: subColor || "#22C55E", mt: "3px" }}>
          {sub}
        </Typography>
      )}
    </Box>
  );
}

/* ── Component ─────────────────────────────────────────── */
function LandingHeroSection({ handleShowContactForm }) {
  const canvasRef = useRef(null);
  const [cookies] = useCookies(["user"]);
  const [activeImg, setActiveImg] = useState(0);
  const [fading, setFading]       = useState(false);

  /* canvas */
  useEffect(() => {
    if (!canvasRef.current) return;
    return initParticleCanvas(canvasRef.current);
  }, []);

  /* image carousel */
  useEffect(() => {
    const timer = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setActiveImg((prev) => (prev + 1) % CAROUSEL_IMAGES.length);
        setFading(false);
      }, 500);
    }, 3200);
    return () => clearInterval(timer);
  }, []);

  const signupHref = cookies.user && cookies.user !== "undefined"
    ? "/filter/influencers"
    : "/authenticate/signup";

  return (
    <Box
      sx={{
        position:   "relative",
        minHeight:  "100vh",
        background: "#0D1B3E",
        overflow:   "hidden",
        display:    "flex",
        alignItems: "center",
      }}
    >
      {/* ── Particle canvas ── */}
      <canvas
        ref={canvasRef}
        style={{
          position: "absolute",
          inset:    0,
          width:    "100%",
          height:   "100%",
          display:  "block",
          zIndex:   0,
        }}
      />

      {/* ── Ambient gradient ── */}
      <Box sx={{
        position:      "absolute",
        inset:         0,
        background:
          "radial-gradient(ellipse at 15% 55%, rgba(255,107,53,0.1) 0%, transparent 45%)," +
          "radial-gradient(ellipse at 75% 15%, rgba(29,158,117,0.06) 0%, transparent 45%)",
        zIndex:        0,
        pointerEvents: "none",
      }} />

      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          zIndex:   1,
          pt: { xs: "108px", md: "150px" },
          pb: { xs: "64px",  md: "90px"  },
          px: { xs: "20px",  md: "80px"  },
        }}
      >
        <Grid container alignItems="center" spacing={{ xs: 6, md: 8 }}>

          {/* ════════════════════ LEFT ════════════════════ */}
          <Grid item xs={12} md={6}>

            {/* Badge */}
            <Box className="hero-badge" sx={{ mb: 3 }}>
              <Box component="span" sx={{
                display:       "inline-flex",
                alignItems:    "center",
                gap:           0.6,
                color:         "#FF6B35",
                bgcolor:       "rgba(255,107,53,0.12)",
                border:        "1px solid rgba(255,107,53,0.35)",
                px:            "16px",
                py:            "7px",
                borderRadius:  "100px",
                fontSize:      "11px",
                fontWeight:    700,
                letterSpacing: "0.07em",
                textTransform: "uppercase",
              }}>
                ✦&nbsp;India's #1 Creator Intelligence Platform
              </Box>
            </Box>

            {/* Headline */}
            <Box className="hero-headline">
              <Typography component="h1" sx={{
                fontWeight: 800,
                fontSize:   "clamp(36px, 4.8vw, 62px)",
                lineHeight: 1.12,
                color:      "white",
              }}>
                Find the right creator.
              </Typography>
              <Typography component="h1" sx={{
                fontWeight:                800,
                fontSize:                  "clamp(36px, 4.8vw, 62px)",
                lineHeight:                1.12,
                mb:                        2.5,
                background:                "linear-gradient(90deg, #FF6B35 0%, #FF9F6B 100%)",
                WebkitBackgroundClip:      "text",
                WebkitTextFillColor:       "transparent",
                backgroundClip:            "text",
              }}>
                Every time.
              </Typography>
            </Box>

            {/* Subheadline */}
            <Typography className="hero-sub" component="p" sx={{
              color:     "rgba(255,255,255,0.62)",
              fontSize:  "17px",
              lineHeight: 1.78,
              maxWidth:  "520px",
              mt:        2,
              mb:        4,
            }}>
              Deep intelligence on <Box component="span" sx={{ color: "rgba(255,255,255,0.9)", fontWeight: 600 }}>2M+ Instagram creators</Box> real audience quality,
              verified contacts, and campaign-ready data. Built for brands and
              agencies that run campaigns that actually convert.
            </Typography>

            {/* CTA row */}
            <Box className="hero-cta" sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 4 }}>
              <Button
                href={signupHref}
                className="cta-glow"
                sx={{
                  position:      "relative",
                  overflow:      "hidden",
                  background:    "linear-gradient(135deg, #FF6B35 0%, #FF4500 100%)",
                  color:         "white",
                  fontWeight:    700,
                  fontSize:      "15px",
                  px:            "30px",
                  py:            "15px",
                  borderRadius:  "12px",
                  textTransform: "none",
                  boxShadow:     "0 4px 20px rgba(255,107,53,0.35)",
                  "&:hover": {
                    background:  "linear-gradient(135deg, #e85520 0%, #cc3300 100%)",
                    transform:   "translateY(-3px)",
                    boxShadow:   "0 10px 36px rgba(255,107,53,0.5)",
                  },
                  transition:    "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
                }}
              >
                Start discovering free →
              </Button>
            </Box>

            {/* Trust avatars */}
            <Box className="hero-trust" sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box sx={{ display: "flex" }}>
                {[
                  { bg: "#FF6B35", i: "AS" },
                  { bg: "#1D9E75", i: "RK" },
                  { bg: "#F5A623", i: "PM" },
                  { bg: "#4A90E2", i: "NT" },
                  { bg: "#9B59B6", i: "VD" },
                ].map((av, idx) => (
                  <Box key={idx} sx={{
                    width:          28,
                    height:         28,
                    borderRadius:   "50%",
                    bgcolor:        av.bg,
                    border:         "2px solid #0D1B3E",
                    display:        "flex",
                    alignItems:     "center",
                    justifyContent: "center",
                    fontSize:       "8px",
                    fontWeight:     700,
                    color:          "white",
                    ml:             idx === 0 ? 0 : "-8px",
                    zIndex:         5 - idx,
                    position:       "relative",
                  }}>
                    {av.i}
                  </Box>
                ))}
              </Box>
              <Typography sx={{ fontSize: "13px", color: "rgba(255,255,255,0.5)" }}>
                <Box component="span" sx={{ fontWeight: 700, color: "white" }}>3000+</Box>
                {" "}campaigns powered by Meesha
              </Typography>
            </Box>

            {/* Quick stats strip */}
            <Box className="hero-trust" sx={{
              display:       "flex",
              gap:           3,
              mt:            4,
              pt:            3,
              borderTop:     "1px solid rgba(255,255,255,0.08)",
            }}>
              {[
                { v: "2M+",  l: "Creators indexed" },
                { v: "95%",  l: "Contact reach rate" },
                { v: "< 60s",l: "To find a match"   },
              ].map((s, i) => (
                <Box key={i}>
                  <Typography sx={{ fontSize: "20px", fontWeight: 800, color: "#FF6B35", lineHeight: 1 }}>
                    {s.v}
                  </Typography>
                  <Typography sx={{ fontSize: "11px", color: "rgba(255,255,255,0.4)", mt: 0.4 }}>
                    {s.l}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Grid>

          {/* ════════════════════ RIGHT: Carousel ════════════════════ */}
          <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: { xs: "center", md: "flex-end" } }}>
            <Box sx={{ position: "relative", width: "100%", maxWidth: "400px" }}>

              {/* Coral glow behind card — gradient-only, no CSS blur (perf) */}
              <Box sx={{
                position:     "absolute",
                width:        340,
                height:       340,
                background:   "radial-gradient(circle, rgba(255,107,53,0.20) 0%, rgba(255,107,53,0.08) 40%, transparent 70%)",
                borderRadius: "50%",
                top:          -60,
                right:        -60,
                zIndex:       0,
                pointerEvents: "none",
              }} />
              <Box sx={{
                position:     "absolute",
                width:        240,
                height:       240,
                background:   "radial-gradient(circle, rgba(29,158,117,0.14) 0%, rgba(29,158,117,0.05) 45%, transparent 70%)",
                borderRadius: "50%",
                bottom:       -30,
                left:         -30,
                zIndex:       0,
                pointerEvents: "none",
              }} />

              {/* ── Main showcase card ── */}
              <Box
                className="hero-card"
                sx={{
                  position:     "relative",
                  zIndex:       1,
                  borderRadius: "28px",
                  overflow:     "hidden",
                  height:       { xs: "400px", md: "520px" },
                  boxShadow:    "0 40px 100px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.08)",
                  background:   "#1a2c55",
                }}
              >
                {/* Cycling influencer image */}
                <Box
                  component="img"
                  src={CAROUSEL_IMAGES[activeImg]}
                  alt="Creator"
                  sx={{
                    position:   "absolute",
                    inset:      0,
                    width:      "100%",
                    height:     "100%",
                    objectFit:  "cover",
                    objectPosition: "center top",
                    opacity:    fading ? 0 : 1,
                    transition: "opacity 0.55s cubic-bezier(0.4, 0, 0.2, 1)",
                  }}
                />

                {/* Subtle gradient overlay (top) — keeps badge readable */}
                <Box sx={{
                  position:   "absolute",
                  top:        0, left: 0, right: 0,
                  height:     "120px",
                  background: "linear-gradient(to bottom, rgba(13,27,62,0.7), transparent)",
                  zIndex:     2,
                }} />

                {/* Bottom gradient with stats */}
                <Box sx={{
                  position:   "absolute",
                  bottom:     0, left: 0, right: 0,
                  background: "linear-gradient(to top, rgba(10,20,50,0.97) 0%, rgba(10,20,50,0.8) 50%, transparent 100%)",
                  p:          "20px 20px 16px",
                  zIndex:     2,
                }}>
                  {/* Creator name + handle */}
                  <Box sx={{ mb: 1.5 }}>
                    <Typography sx={{ color: "white", fontWeight: 700, fontSize: "15px", lineHeight: 1.2, transition: "opacity 0.4s ease", opacity: fading ? 0 : 1 }}>
                      {CREATORS[activeImg].name}
                    </Typography>
                    <Typography sx={{ color: "rgba(255,255,255,0.5)", fontSize: "12px", mt: 0.3, transition: "opacity 0.4s ease", opacity: fading ? 0 : 1 }}>
                      {CREATORS[activeImg].niche}
                    </Typography>
                  </Box>

                  {/* Stats grid */}
                  <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "8px" }}>
                    {[
                      { v: CREATORS[activeImg].followers,  l: "Followers"  },
                      { v: CREATORS[activeImg].engagement, l: "Engagement" },
                      { v: CREATORS[activeImg].authScore,  l: "Auth Score" },
                    ].map((s, i) => (
                      <Box key={i} sx={{
                        bgcolor:      "rgba(255,255,255,0.08)",
                        borderRadius: "10px",
                        p:            "8px 10px",
                        border:       "1px solid rgba(255,255,255,0.06)",
                      }}>
                        <Typography sx={{ color: "white", fontWeight: 700, fontSize: "14px", lineHeight: 1 }}>
                          {s.v}
                        </Typography>
                        <Typography sx={{ color: "rgba(255,255,255,0.4)", fontSize: "9px", mt: 0.4, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                          {s.l}
                        </Typography>
                      </Box>
                    ))}
                  </Box>

                  {/* Reveal contact button */}
                  <Box sx={{
                    mt:            "12px",
                    display:       "flex",
                    alignItems:    "center",
                    justifyContent: "space-between",
                    bgcolor:       "rgba(255,255,255,0.05)",
                    border:        "1px solid rgba(255,255,255,0.08)",
                    borderRadius:  "10px",
                    p:             "10px 14px",
                  }}>
                    <Typography sx={{ color: "rgba(255,255,255,0.4)", fontSize: "13px", letterSpacing: "0.12em" }}>
                      📞  ••••• ••••••
                    </Typography>
                    <Box sx={{
                      bgcolor:       "#FF6B35",
                      color:         "white",
                      fontSize:      "11px",
                      fontWeight:    700,
                      px:            "14px",
                      py:            "6px",
                      borderRadius:  "20px",
                      cursor:        "pointer",
                      boxShadow:     "0 4px 12px rgba(255,107,53,0.4)",
                    }}>
                      Reveal contact →
                    </Box>
                  </Box>
                </Box>

                {/* LIVE badge — top-left */}
                <Box sx={{
                  position:      "absolute",
                  top:           16,
                  left:          16,
                  zIndex:        3,
                  bgcolor:       "rgba(10,20,50,0.75)",
                  backdropFilter: "blur(12px)",
                  border:        "1px solid rgba(255,255,255,0.12)",
                  borderRadius:  "20px",
                  px:            1.5,
                  py:            0.7,
                  display:       "flex",
                  alignItems:    "center",
                  gap:           0.8,
                }}>
                  <Box className="pulse-dot" sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: "#22C55E" }} />
                  <Typography sx={{ color: "white", fontSize: "11px", fontWeight: 600 }}>
                    Live data
                  </Typography>
                </Box>

                {/* Verified badge — top-right */}
                <Box sx={{
                  position:      "absolute",
                  top:           16,
                  right:         16,
                  zIndex:        3,
                  bgcolor:       "rgba(34,197,94,0.15)",
                  backdropFilter: "blur(12px)",
                  border:        "1px solid rgba(34,197,94,0.3)",
                  borderRadius:  "20px",
                  px:            1.5,
                  py:            0.7,
                  display:       "flex",
                  alignItems:    "center",
                  gap:           0.5,
                }}>
                  <Typography sx={{ color: "#22C55E", fontSize: "11px", fontWeight: 700 }}>✓ Verified</Typography>
                </Box>
              </Box>

              {/* ── Floating badge — Engagement ── */}
              <MetricBadge
                label="Engagement Rate"
                value={CREATORS[activeImg].engagement}
                sub={CREATORS[activeImg].engLabel}
                dark={false}
                delay="0.3s"
                style={{ left: "-28px", top: "38%" }}
              />

              {/* ── Floating badge — Auth Score ── */}
              <MetricBadge
                label="Auth Score"
                value={CREATORS[activeImg].authScore}
                sub={CREATORS[activeImg].authLabel}
                subColor="rgba(255,255,255,0.45)"
                dark={true}
                delay="0.6s"
                style={{ right: "-20px", bottom: "22%" }}
              />

              {/* ── Image progress dots ── */}
              <Box sx={{
                position:       "absolute",
                bottom:         "-28px",
                left:           "50%",
                transform:      "translateX(-50%)",
                display:        "flex",
                gap:            "6px",
                alignItems:     "center",
              }}>
                {CAROUSEL_IMAGES.map((_, i) => (
                  <Box
                    key={i}
                    onClick={() => { setFading(true); setTimeout(() => { setActiveImg(i); setFading(false); }, 300); }}
                    sx={{
                      width:        i === activeImg ? 20 : 6,
                      height:       6,
                      borderRadius: "3px",
                      bgcolor:      i === activeImg ? "#FF6B35" : "rgba(255,255,255,0.25)",
                      cursor:       "pointer",
                      transition:   "all 0.35s ease",
                    }}
                  />
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default LandingHeroSection;
